import React from "react";
import ElfsightWidget from "../common/ElfsightWidget";
import Reveal from "../common/Reveal";

const Testimonials = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="tnf-container">
        <Reveal className="text-center max-w-2xl mx-auto mb-10">
          <span className="tnf-eyebrow">Reviews</span>
          <h2 className="font-display text-[32px] sm:text-[42px] font-extrabold text-[#0e0e10] mt-3 leading-[1.08]">
            What Our Clients Say
          </h2>
          <p className="text-[#3b3b3b]/80 text-[16px] mt-3">
            Real Google reviews from our Freehold Raceway Mall customers.
          </p>
        </Reveal>

        <Reveal className="min-h-[300px]">
          <ElfsightWidget appId="b040af1c-a34e-48e5-9e49-db1f819c135a" />
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
